<template>
  <div class="row no-gutters">
    <div class="col order-sm-1 order-2">
      <button
        class="btn btn-primary btn-block order-up-button"
        @click="moveUp(id)"
        v-tooltip:top.delay="'Move Up'"
      >
        <i class="fas fa-angle-up"></i>
      </button>
    </div>
    <div class="col order-sm-2 order-3">
      <button
        class="btn btn-secondary btn-block order-top-button"
        @click="moveTop(id)"
        v-tooltip:top.delay="'Move To Top'"
      >
        <i class="fas fa-angle-double-up"></i>
      </button>
    </div>
    <div class="w-100 d-none d-sm-block order-sm-3"></div>
    <div class="col order-sm-4 order-6">
      <button
        class="btn btn-primary btn-block order-down-button"
        @click="moveDown(id)"
        v-tooltip:left.delay="'Move Down'"
      >
        <i class="fas fa-angle-down"></i>
      </button>
    </div>
    <div class="w-100 d-block d-sm-none order-4"></div>
    <div class="col order-sm-5 order-7">
      <button
        class="btn btn-secondary btn-block order-bottom-button"
        @click="moveBottom(id)"
        v-tooltip:right.delay="'Move to Bottom'"
      >
        <i class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="w-100 d-none d-sm-block order-sm-6"></div>
    <div class="col order-sm-7 order-1">
      <button
        class="btn btn-warning btn-block return-button"
        @click="returnToSorting(id)"
        v-tooltip:bottom.delay="'Return to Submissions'"
      >
        <i class="fas fa-undo-alt"></i>
      </button>
    </div>
    <div class="col order-sm-8 order-5">
      <button
        class="btn btn-danger bg-utred border-utred btn-block queue-reject-button"
        @click="reject(id)"
        v-tooltip:bottom.delay="'Reject'"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</template>


<script>
export default {
  name: "SubButtons",

  props: {
    id: {
      type: Number,
      required: true
    },
  },

  methods: {
    reject(id) {
      let self = this;
      axios
        .post("/api/queues/posting/" + id + "/reject")
        .then(function(response) {
          self.$emit("submission-dismissed", self);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    returnToSorting(id) {
      let self = this;
      axios
        .post("/api/queues/posting/" + id + "/return")
        .then(function(response) {
          self.$emit("submission-dismissed", self);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    moveUp(id) {
      let self = this;
      axios
        .post("/api/queues/posting/" + id + "/move/up")
        .then(function(response) {
          self.$emit("submission-move-up", self);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    moveTop(id) {
      let self = this;
      axios
        .post("/api/queues/posting/" + id + "/move/top")
        .then(function(response) {
          self.$emit("submission-move-top", self);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    moveDown(id) {
      let self = this;
      axios
        .post("/api/queues/posting/" + id + "/move/down")
        .then(function(response) {
          self.$emit("submission-move-down", self);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    moveBottom(id) {
      let self = this;
      axios
        .post("/api/queues/posting/" + id + "/move/bottom")
        .then(function(response) {
          self.$emit("submission-move-bottom", self);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>